import { calculateAge } from './index';

interface Field {
  name: string;
  labelName: string;
  placeholder: string;
  type: string;
  isInvalid: boolean;
  validationMessage: string;
  required: boolean;
  entityKey: string;
  className: string;
  value: string;
}
let userName;

/* Functions */
const validate = (arr: Field[]) => {
  let isValid = true;
  const validatedArr = arr.map((obj: Field) => {
    const item = checkForErrors(obj);
    if (item.isInvalid) {
      isValid = false;
    }
    return item;
  });

  return { validatedArr, isValid };
};

const notSupportedPAN = [
  {
    regex: /^[A-Z]{3}[H][A-Z][0-9]{4}[A-Z]$/,
    type: 'HUF',
  },
  {
    regex: /^[A-Z]{3}[F][A-Z][0-9]{4}[A-Z]$/,
    type: 'Firm',
  },
  {
    regex: /^[A-Z]{3}[C][A-Z][0-9]{4}[A-Z]$/,
    type: 'Company',
  },
  {
    regex: /^[A-Z]{3}[A][A-Z][0-9]{4}[A-Z]$/,
    type: 'AOP',
  },
  {
    regex: /^[A-Z]{3}[T][A-Z][0-9]{4}[A-Z]$/,
    type: 'Trust',
  },
  {
    regex: /^[A-Z]{3}[B][A-Z][0-9]{4}[A-Z]$/,
    type: 'BOI',
  },
  {
    regex: /^[A-Z]{3}[L][A-Z][0-9]{4}[A-Z]$/,
    type: 'Local Authority',
  },
  {
    regex: /^[A-Z]{3}[J][A-Z][0-9]{4}[A-Z]$/,
    type: 'Artificial Judicial Person',
  },
  {
    regex: /^[A-Z]{3}[G][A-Z][0-9]{4}[A-Z]$/,
    type: 'Government Agency',
  },
];

const checkForErrors = (obj: Field) => {
  const { name, value } = obj;
  const val = typeof value === 'string' ? value.trim() : value;
  const regexDate = /^(0[1-9]|[12][0-9]|3[01])[\/](0[1-9]|1[012])[\/]\d{4}$/;

  switch (name) {
    case 'pan':
      const regexPan = /^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]$/;
      obj.isInvalid = !regexPan.test(val);
      obj.validationMessage =
        'Please enter correct PAN number (only for individuals)';
      notSupportedPAN.forEach((item) => {
        if (item.regex.test(val)) {
          obj.validationMessage = `This seems a ${item.type}'s PAN. We, at the moment, support investments from individual PANs only`;
        }
      });
      break;
    case 'fullName':
      const regexName = /^([a-zA-Z ']*)$/;
      obj.isInvalid = !regexName.test(val);
      obj.validationMessage =
        'Name should not contain special characters/numeric digits';
      if (!obj.isInvalid) {
        userName = val;
      }
      break;
    case 'accountNo':
      const regexNum = /^\d+$/;
      obj.isInvalid = !regexNum.test(val);
      obj.validationMessage = 'Enter valid account number';
      break;
    case 'select-nominee':
      break;
    case 'isTaxPayerOutsideIndia':
      break;
    case 'ifscCode':
      const regexp = /^[a-zA-Z]{4}0[A-Z0-9]{6}$/;
      obj.isInvalid = !regexp.test(val);
      obj.validationMessage = 'Invalid IFSC code, kindly check';
      break;
    case 'phone':
      const regx = /^[0-9]{10}$/;
      obj.isInvalid = !regx.test(val);
      obj.validationMessage = 'Enter valid Number';
      break;
    case 'pincode':
      obj.isInvalid = val.length !== 6;
      obj.validationMessage = 'Enter a valid pincode';
      break;
    case 'dateOfBirth':
      const dateArr = val.split('/');
      const month = dateArr[0];
      dateArr[0] = dateArr[1];
      dateArr[1] = month;
      const dob = dateArr.join('/');
      const investorAge = calculateAge(new Date(dob));
      obj.isInvalid =
        !regexDate.test(val) || investorAge > 100 || investorAge < 18
          ? true
          : false;
      if (investorAge > 100) {
        obj.validationMessage = 'Investor’s age should be less than 100 years';
      } else if (investorAge < 18) {
        obj.validationMessage = 'Investor’s age should be more than 18 years';
      }
      break;
    case 'nomineeDateOfBirth':
      const nomineeDateArr = val.split('/');
      const nomineeDobMonth = nomineeDateArr[0];
      nomineeDateArr[0] = nomineeDateArr[1];
      nomineeDateArr[1] = nomineeDobMonth;
      const nomineeDob = nomineeDateArr.join('/');
      const nomineeAge = calculateAge(new Date(nomineeDob));
      obj.isInvalid = !regexDate.test(val) || nomineeAge > 100 ? true : false;
      if (nomineeAge > 100) {
        obj.validationMessage = 'Nominee’s age should be less than 100 years';
      } else if (nomineeAge < 18) {
        obj.validationMessage = 'Nominee’s age should be more than 18 years';
      }
      break;
    case 'nomineeName':
      const regexNomineeName = /^([a-zA-Z .']*)$/;
      obj.isInvalid = !regexNomineeName.test(val) || val === userName;
      obj.validationMessage =
        'Nominee name should not contain special characters/numeric digits';
      if (val === userName) {
        obj.validationMessage =
          'Nominee name can not be same as investor name, kindly check';
      }
      break;
    default:
      obj.isInvalid = !val;
      break;
  }

  return obj;
};

export const validateAllFields = (arr: Field[]) => {
  let isValid = true;
  const validatedArr = arr.map((obj: Field) => {
    const item = checkForFieldsErrors(obj);
    if (item.isInvalid) {
      isValid = false;
    }
    return item;
  });

  return { validatedArr, isValid };
};

const checkForFieldsErrors = (obj: Field) => {
  const { name, value } = obj;
  const val = typeof value === 'string' ? value.trim() : value;
  const isNotEmptyRegex = /.*\S.*/;
  switch (name) {
    case 'fullName':
      obj.isInvalid = !isNotEmptyRegex.test(val);
      obj.validationMessage = 'Enter your full name';
      break;
    case 'gender':
      obj.isInvalid = !isNotEmptyRegex.test(val);
      obj.validationMessage = 'Select your gender';
      break;
    case 'maritalStatus':
      obj.isInvalid = val === null || !isNotEmptyRegex.test(val);
      obj.validationMessage = 'Select your Marital Status';
      break;
    case 'pan':
      const regexPan = /[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}?$/;
      obj.isInvalid = !regexPan.test(val);
      obj.validationMessage = 'Enter valid PAN';
      break;
    case 'accountNo':
      const regexNum = /^\d+$/;
      obj.isInvalid = !regexNum.test(val);
      obj.validationMessage = 'Enter valid account number';
      break;
    case 'nomineeName':
      obj.isInvalid = false;
      break;
    case 'ifscCode':
      const regexp = /^[a-zA-Z]{4}0[A-Z0-9]{6}$/;
      obj.isInvalid = !regexp.test(val);
      obj.validationMessage = 'Enter valid IFSC';
      break;
    case 'phone':
      const regx = /^[0-9]{10}$/;
      obj.isInvalid = !regx.test(val);
      obj.validationMessage = 'Enter your Phone Number';
      break;
    case 'pincode':
      obj.isInvalid = val.length !== 6;
      obj.validationMessage = 'Enter a valid pincode';
      break;
    case 'dateOfBirth':
      const regexDate =
        /^(0[1-9]|[12][0-9]|3[01])[\/](0[1-9]|1[012])[\/]\d{4}$/;
      obj.isInvalid = !regexDate.test(val);
      obj.validationMessage = 'Enter date of birth in (dd/mm/yyy) format';
      break;
    case 'nomineeAdded':
      obj.isInvalid = false;
      break;
    default:
      obj.isInvalid = !val;
      break;
  }

  return obj;
};

export default validate;



// WEBPACK FOOTER //
// ./utils/formValidator.ts